export default __webpack_public_path__ + "static/media/calender.7499aa87.svg";